export default {
  campo: {},
  campos: [],
  fields: {},
  errorArray: [],
  dialog: false,
};
